import { helper } from '@ember/component/helper';

function blurTarget([handler]) {
  return function (...args) {
    args[0].target.blur();
    if (handler) handler(...args);
  };
}

export default helper(blurTarget);
